import { createSlice } from "@reduxjs/toolkit";
import {
  getAllSystemPrompts,
  getAllSystemPromptsByType,
} from "./systemPromptDetailsAction";

export const systemPromptSlice = createSlice({
  name: "systemPromptDetail",
  initialState: {
    loading: false,
    data: [],
    message: "",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllSystemPrompts.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllSystemPrompts.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message || "";
      state.total = payload.total || 0;
      state.error = null;
    });
    builder.addCase(getAllSystemPrompts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "An error occurred";
    });
  },
});

export const systemPromptTypeSlice = createSlice({
  name: "systemPromptTypeDetail",
  initialState: {
    loading: false,
    data: [],
    message: "",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllSystemPromptsByType.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getAllSystemPromptsByType.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.data = payload.data;
        state.message = payload.message || "";
        state.total = payload.total || 0;
        state.error = null;
      }
    );
    builder.addCase(getAllSystemPromptsByType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "An error occurred";
    });
  },
});
